/**
 * Vuex (Vue 3 + Vuex 4)
 * https://vuex.vuejs.org/
 */

import { createStore } from 'vuex';



const now = new Date();

const store = createStore({
  state: {
    // 当前用户
    user: {
      name: 'coffce',
      imgId: '1',
    },
    // 会话列表
    sessions: [
      {
        id: 1,
        user: {
          name: '示例介绍',
          imgId: '3',
        },
        messages: [
          {
            content:
              '123',
            date: now,
            self:false,
          }
        ],
      },
      {
        id: 2,
        user: {
          name: 'webpack',
          imgId: '2',
        },
        messages: [],
      },
    ],
    // 当前选中的会话
    currentSessionId: 1,
    // 过滤出只包含这个key的会话
    filterKey: '',
  },
  mutations: {
    INIT_DATA(state) {
      let data = localStorage.getItem('vue-chat-session');
      if (data) {
        state.sessions = JSON.parse(data);
      }
    },
    // 发送消息
    SEND_MESSAGE(state, content) {
      let session = state.sessions.find((item) => item.id === state.currentSessionId);
      if (session) {
        session.messages.push({
          content: content,
          date: new Date(),
          self: true,
        });
      }
    },
    // 选择会话
    SELECT_SESSION(state, id) {
      state.currentSessionId = id;
      console.log("SELECT_SESSION="+id);
    },
    // 搜索
    SET_FILTER_KEY(state, value) {
      state.filterKey = value;
    },
  },
  actions: {
    initData({ commit }) {
      commit('INIT_DATA');
    },
    sendMessage({ commit }, content) {
      commit('SEND_MESSAGE', content);
    },
    selectSession({ commit }, id) {
      commit('SELECT_SESSION', id);
    },
    search({ commit }, value) {
      commit('SET_FILTER_KEY', value);
    },
  },
  plugins: [
    (store) => {
      store.subscribe(
        (mutation, state) => {
          console.log('CHANGE: ', state.sessions);
          localStorage.setItem('vue-chat-session', JSON.stringify(state.sessions));
        },
      );
    },
  ],
});

export default store;